<template>
  <v-dialog
    persistent
    v-model="dialog"
    max-width="290"
  >
    <v-card>
      <v-card-title class="headline">Atualização encontrada</v-card-title>

      <v-card-text>
        O sistema será atualizado em {{ seconds }} segundos.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="green darken-4"
          flat="flat"
          @click="$emit('confirm')"
        >
          Atualizar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'forced-update-dialog',

  props: {
    visibility: {
      type: Boolean,
      required: true
    },

    seconds: {
      type: Number,
      default: 5
    }
  },

  computed: {
    dialog: {
      get () {
        return this.visibility
      },

      set () {}
    }
  }
}
</script>
